// @flow
import Vue from 'vue'
import {
  RESET_SELECTED_FILTERS,
  SET_SELECTED_MODALITIES,
  SET_SELECTED_PRODUCT_COLLECTIONS,
  SET_SELECTED_REGIONS,
  SET_SELECTED_TERMS
} from '../store/modules/selection/mutation-types'
import {
  SET_SELECTED_PRODUCT,
  SET_DATE_EFFECTIVE,
  SET_SELECTED_CUSTOMER_GROUP,
  SET_ENGRAVED_ID,
  SET_PRE_SELECTED_ZONE_ID,
  SET_PRE_SELECTED_STAR_VALUE_ID,
  SET_SELECTED_ZONE,
  SET_SELECTED_STAR_VALUE,
  SET_SELECTED_CLASS,
  SET_SELECTED_TERM,
  SET_PRE_SELECTED_CLASS_ID,
  SET_RENEW_SUBSCRIPTION_ID,
  RESET,
  SET_SPECIAL_SALE_SLUG,
  SET_SELECTED_TO_STOP,
  SET_PRE_SELECTED_TO_STOP_ID,
  SET_SELECTED_FROM_STOP,
  SET_PRE_SELECTED_FROM_STOP_ID, SET_PRE_SELECTED_ZONE_CODE
} from '../store/modules/configuration/mutation-types'
import { formatStoreDate, parseDeeplinkDate, constrainDate } from '../utils/date'
import moment from 'moment'

export type UrlParameters = Object

const applyTerms = function (entityDeeplinkIds) {
  const store = Vue.$container.store
  const entities = entityDeeplinkIds.map(
    entityDeeplinkId => store.state.selection.availableFilterEntities.terms.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))).filter(
    e => !!e)
  if (entities.length > 0) {
    store.commit('selection/' + SET_SELECTED_TERMS, entities)
    store.commit('configuration/' + SET_SELECTED_TERM, entities[0])
  }
}
const applyModalities = function (entityDeeplinkIds) {
  const store = Vue.$container.store
  const entities = entityDeeplinkIds.map(
    entityDeeplinkId => store.state.selection.availableFilterEntities.modalities.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))).filter(
    e => !!e)
  if (entities.length > 0) {
    store.commit('selection/' + SET_SELECTED_MODALITIES, entities)
  }
}
const applyCustomerGroup = function (entityDeeplinkId) {
  const store = Vue.$container.store
  const entity = store.state.selection.availableFilterEntities.customerGroups.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))
  if (entity) {
    store.commit('configuration/' + SET_SELECTED_CUSTOMER_GROUP, entity)
  }
}
const applyProductCollections = function (entityDeeplinkIds) {
  const store = Vue.$container.store
  const entities = entityDeeplinkIds.map(
    entityDeeplinkId => store.state.selection.availableFilterEntities.productCollections.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))).filter(
    e => !!e)
  if (entities.length > 0) {
    store.commit('selection/' + SET_SELECTED_PRODUCT_COLLECTIONS, entities)
  }
}
const applyProduct = function (entityDeeplinkId) {
  const store = Vue.$container.store
  const entity = store.state.selection.availableFilterEntities.products.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))
  if (entity) {
    store.commit('configuration/' + SET_SELECTED_PRODUCT, entity)
  }
}
const applyRegions = function (entityDeeplinkIds) {
  const store = Vue.$container.store
  const entities = entityDeeplinkIds.map(
    entityDeeplinkId => store.state.selection.availableFilterEntities.regions.find(({ deeplinkId }) => deeplinkId === String(entityDeeplinkId))).filter(
    e => !!e)
  if (entities.length > 0) {
    store.commit('selection/' + SET_SELECTED_REGIONS, entities)
  }
}
const applyStartDate = function (dateString) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_DATE_EFFECTIVE, dateString)
}
const applyEngravedId = function (engravedId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_ENGRAVED_ID, engravedId)
}
const applyZoneId = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_ZONE, null)
  store.commit('configuration/' + SET_PRE_SELECTED_ZONE_ID, String(entityDeeplinkId))
}
const applyZoneCode = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_ZONE, null)
  store.commit('configuration/' + SET_PRE_SELECTED_ZONE_CODE, String(entityDeeplinkId))
}
const applyStarValue = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_STAR_VALUE, null)
  store.commit('configuration/' + SET_PRE_SELECTED_STAR_VALUE_ID, String(entityDeeplinkId))
}
const applyFromStop = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_FROM_STOP, null)
  store.commit('configuration/' + SET_PRE_SELECTED_FROM_STOP_ID, String(entityDeeplinkId))
}
const applyToStop = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_TO_STOP, null)
  store.commit('configuration/' + SET_PRE_SELECTED_TO_STOP_ID, String(entityDeeplinkId))
}
const applyClass = function (entityDeeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SELECTED_CLASS, null)
  store.commit('configuration/' + SET_PRE_SELECTED_CLASS_ID, String(entityDeeplinkId))
}
const applyRenewSubscription = function (deeplinkId) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_RENEW_SUBSCRIPTION_ID, String(deeplinkId))
}
const applySpecialSale = function (saleSlug) {
  const store = Vue.$container.store
  store.commit('configuration/' + SET_SPECIAL_SALE_SLUG, saleSlug)
}

const clearSelectionAndConfiguration = function () {
  const store = Vue.$container.store
  store.commit('selection/' + RESET_SELECTED_FILTERS)
  store.commit('configuration/' + RESET)
}

const applyCriteriaFromUrlParameters = function (parameters: UrlParameters) {
  const terms = []
  const modalities = []
  const productCollections = []
  const regions = []
  let customerGroup = null
  let productClass = null
  let product = null
  let renewSubscription = null
  let saleSlug = null
  let criteriaFound = false
  let startDate: ?string = null
  let engravedId = null
  let zoneId = null
  let zoneCode = null
  let starValue = null
  let fromStop = null
  let toStop = null

  for (const paramName in parameters) {
    switch (true) {
      case RegExp('propositionTerm(\\[(\\d+)\\])').test(paramName):
      case RegExp('tariffTerm(\\[(\\d+)\\])').test(paramName):
        terms.push(parameters[paramName])
        criteriaFound = true
        break
      case RegExp('modality(\\[(\\d+)\\])?').test(paramName):
        modalities.push(parameters[paramName])
        criteriaFound = true
        break
      case paramName === 'customerGroup':
        customerGroup = parameters[paramName]
        criteriaFound = true
        break
      case RegExp('productType(\\[(\\d+)\\])?').test(paramName):
        productCollections.push(parameters[paramName])
        criteriaFound = true
        break
      case RegExp('region(\\[(\\d+)\\])?').test(paramName):
        regions.push(parameters[paramName])
        criteriaFound = true
        break
      case paramName === 'class':
        productClass = parameters[paramName]
        criteriaFound = true
        break
      case paramName === 'productGroupId':
      case paramName === 'proposition':
        product = parameters[paramName]
        criteriaFound = true
        break
      case paramName === 'renewSubscription':
        renewSubscription = parameters[paramName]
        criteriaFound = true
        break
      case paramName === 'sale':
        saleSlug = parameters[paramName]
        criteriaFound = true
        break
      case paramName === 'dateEffective':
        const startDateDate = parseDeeplinkDate(parameters[paramName])
        startDate = formatStoreDate(
          startDateDate ? constrainDate(startDateDate, moment().startOf('day').toDate()) : null
        )
        break
      case paramName === 'engravedId':
        engravedId = parameters[paramName]
        break
      case paramName === 'product_data':
        const data = JSON.parse(parameters[paramName])
        if (data.hasOwnProperty('zoneId')) {
          zoneId = data.zoneId
        }
        if (data.hasOwnProperty('zoneCode')) {
          zoneCode = data.zoneCode
        }
        if (data.hasOwnProperty('starValue')) {
          starValue = data.starValue
        }
        if (data.hasOwnProperty('fromStop')) {
          fromStop = data.fromStop
        }
        if (data.hasOwnProperty('toStop')) {
          toStop = data.toStop
        }
        break
    }
  }
  if (criteriaFound) {
    clearSelectionAndConfiguration()
  }
  applyTerms(terms)
  applyModalities(modalities)
  applyProductCollections(productCollections)
  applyRegions(regions)
  customerGroup && applyCustomerGroup(customerGroup)
  productClass && applyClass(productClass)
  product && applyProduct(product)
  renewSubscription && applyRenewSubscription(renewSubscription)
  saleSlug && applySpecialSale(saleSlug)
  startDate && applyStartDate(startDate)
  engravedId && applyEngravedId(engravedId)
  zoneId && applyZoneId(zoneId)
  zoneCode && applyZoneCode(zoneCode)
  starValue && applyStarValue(starValue)
  fromStop && applyFromStop(fromStop)
  toStop && applyToStop(toStop)
}

export {
  applyCriteriaFromUrlParameters
}



// WEBPACK FOOTER //
// ./src/deeplink/index.js